import React, {useState} from "react";
import carouselImg1 from '../img/homepage-slim/band3-2025.jpg';
import carouselImg2 from '../img/homepage-slim/band4-2025.jpg';
import carouselImg3 from '../img/homepage-slim/band5-2025.jpg';
import carouselImg4 from '../img/homepage-slim/band6-2025.jpg';
import carouselImg5 from '../img/homepage-slim/band2-2025.jpg';
import carouselImg6 from '../img/homepage-slim/band1-2025.jpg';

import fomImg from '../img/FOM_logo.jpg';
import wccImg from '../img/wcc-logo-text.png';
import Container from "react-bootstrap/Container";
import {Alert, Carousel, Col, Row} from "react-bootstrap";
// import {Link} from "react-router-dom";
// import PFDateAndDesc from "../common/pfDateAndDesc";
// import PFFinale from "../common/pfFinale";
import PastPFDateAndDesc from "../common/pastPFDateAndDesc";


const Home = () => {
    const [index, setIndex] = useState(0);
    let carouselImg = [carouselImg1, carouselImg2, carouselImg3, carouselImg4, carouselImg5, carouselImg6]

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (
        <>
            <Container fluid>
                <Row className="justify-content-md-center">
                    <Col className="mx-auto">

                        {/*<Row className="mb-3">*/}
                        {/*    <Col xs={12} md={6} className="mb-3 mb-md-0">*/}
                        {/*        <Alert variant="success" className="h-100 mb-0 d-flex flex-column justify-content-center">*/}
                        {/*            <PFDateAndDesc/>*/}
                        {/*        </Alert>*/}
                        {/*    </Col>*/}
                        {/*    <Col xs={12} md={6}>*/}
                        {/*        <Alert variant="primary" className="h-100 mb-0 d-flex flex-column justify-content-center">*/}
                        {/*            <PFFinale/>*/}
                        {/*        </Alert>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}

                        <Alert variant="info" className="mb-3 text-center">
                            <PastPFDateAndDesc/>
                        </Alert>

                        <Carousel activeIndex={index} onSelect={handleSelect}>
                            {Array.from({length: 6}).map((_, index) => (
                                <Carousel.Item key={index}>
                                    <img src={carouselImg[(index)]} alt="pf band" className="img-fluid"/>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                        <br/>

                        <p className="text-center">
                            Winchester Porchfest is a free, one-day community music celebration where local musicians
                            perform on front porches, driveways, and patios across town.
                            {/*Grab your neighbors and*/}
                            {/*stroll from venue to venue — you never know what you'll discover. Join us on Saturday,*/}
                            {/*June 13, 2026!*/}
                        </p>

                        {/*<p className="text-center">*/}
                        {/*    <Link to="/register" reloadDocument="true">Register</Link> as a host or*/}
                        {/*    performer &nbsp;·&nbsp; browse <Link to="/acts"*/}
                        {/*    reloadDocument="true">acts</Link> and <Link to="/venues"*/}
                        {/*    reloadDocument="true">venues</Link> &nbsp;·&nbsp; check out*/}
                        {/*    our <Link to="/faq" reloadDocument="true">FAQ</Link>*/}
                        {/*</p>*/}
                        {/*<p className="text-center">*/}
                        {/*    Browse <Link to="/acts" reloadDocument="true">acts</Link> and <Link to="/venues"*/}
                        {/*    reloadDocument="true">venues</Link> &nbsp;·&nbsp; Check out*/}
                        {/*    our <Link to="/faq" reloadDocument="true">FAQ</Link>*/}
                        {/*</p>*/}

                    </Col>
                </Row>
            </Container>

            <Container fluid className="home-footer">
                <Row className="mb-3">
                    <Col className="mx-auto">
                        <p className="text-muted small text-center">
                            By attending Winchester Porchfest, you participate at your own risk and release all
                            performers, hosts, volunteers, and organizers from liability. You also consent to being
                            photographed and filmed.
                        </p>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col className="mx-auto social">
                        <a href="https://www.facebook.com/Winchester-Porch-Fest-108163394041876/"
                           className="social-links facebook" target="_blank" rel="noreferrer"><i
                            className="bi bi-facebook"></i></a>
                        <a href="https://x.com/WPorchfest"
                           className="social-links twitter" target="_blank" rel="noreferrer"><i
                            className="bi bi-twitter-x"></i></a>
                        <a href="https://www.instagram.com/winporchfest/"
                           className="social-links instagram" target="_blank" rel="noreferrer"><i
                            className="bi bi-instagram"></i></a>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        <a href="https://fomwps.wixsite.com/winchester-music" target="_blank" rel="noreferrer"
                           className="sponsor">
                            <img src={fomImg} alt="Winchester Friends of Music"/>
                        </a>
                        <a href="https://winchesterculturalcouncil.org" target="_blank" rel="noreferrer"
                           className="sponsor">
                            <img src={wccImg} alt="Winchester Cultural Council"/>
                        </a>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Home;
